<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description:
-->
<template>
  <div class="lc-steps">
    <div :class="['lc-steps__header']">
      <div
        v-for="(step, index) in steps"
        :key="'step_' + index"
        :class="['lc-step', value == index ? 'is-process' : '', index < value ? 'is-success' : '']"
        :style="stepStyle(index)"
      >
        <div class="lc-step__header">
          <div class="lc-step__headerBase">
            <div class="lc-step__header-style3" :class="stepClass(index)">{{ step.data.attrs.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lc-steps__contents">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'LcSteps',
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    value: {
      type: Number,
      default: 0
    },
  },
  watch: {},
  data() {
    return {};
  },
  computed: {},
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {
    stepStyle(index) {
      const style = {};
      style.flexBasis = 100 / this.steps.length + '%';
      if (index + 1 == this.steps.length) {
        style.flexBasis += ' !important';
      }
      return style;
    },
    stepClass(index) {
      let styles = [];
      if (index != 0) {
        styles.push('with-before');
      }
      if (index !== this.steps.length - 1) {
        styles.push('with-after');
      }
      if (index == this.steps.length - 1) {
        styles.push('width-end');
      }
      return styles;
    }
  }
};
</script>
